import React, { useState } from "react";
import "./PerfEvalCEO.css";
import axios from "axios";
import PerfEvalCEOTable from "./PerfEvalCEOTable.jsx";
import PerfEvalCEOForm from "./PerfEvalCEOForm.jsx";
import PerfEvalCEOFormEdit from "./PerfEvalCEOFormEdit.jsx";
import { RingLoader } from "react-spinners";
import { css } from "@emotion/react";

const override = css`
  display: block;
  margin: 0 auto;
  margin-top: 45px;
  border-color: red;
`;
export default function PerfEvalCEO(props) {
  const [table, setTable] = useState(true);
  const [editForm, setEditForm] = useState(false);
  const [editData, setEditData] = useState({});
  const [SelectedEmp, setSelectedEmp] = useState("");
  const [EmpName, setEmpName] = useState("");
  const [loading, setLoading] = useState(false);

  const [Monthyear, setMonthyear] = useState("");
  const [Communication, setCommunication] = useState("5");
  const [Collaboration, setCollaboration] = useState("5");
  const [Problemsolving, setProblemsolving] = useState("5");
  const [Quality, setQuality] = useState("5");
  const [Attendance, setAttendance] = useState("5");
  const [Meetdeadline, setMeetdeadline] = useState("5");

  const SetNameID = (Name, ID) => {
    setEmpName(Name);
    setSelectedEmp(ID);
  };

  const HandleEdit = (type, e) => {
    if (type === "Monthyear") {
      setMonthyear(e);
    }
    if (e > 0 && e < 11) {
      if (type === "Communication") {
        setCommunication(e);
      } else if (type === "Collaboration") {
        setCollaboration(e);
      } else if (type === "Problemsolving") {
        setProblemsolving(e);
      } else if (type === "Quality") {
        setQuality(e);
      } else if (type === "Attendance") {
        setAttendance(e);
      } else if (type === "Meetdeadline") {
        setMeetdeadline(e);
      }
    }
  };

  const handleAddPerfEvalCEO = () => {
    // // console.log("clicked1");
    setTable(false);
  };
  const RefreshTable = async () => {
    // // console.log("clicked1");
    await setTable(false);
    await setTable(true);
  };
  const handleEditPerfEvalCEO = (e) => {
    console.log(e);
    // console.log("clicked6");

    setEditForm(true);
    setEditData(e);
  };
  const handleFormClose = () => {
    // // console.log("clicked1");
    setTable(true);
  };
  const handleEditFormClose = () => {
    // console.log("clicked5");

    setEditForm(false);
  };

  const handlePerfEvalCEOEditUpdate = (newInfo, id) => {
    axios
      .put(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/perfeval-ceo/" +
          id,
        newInfo,
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((res) => {
        setTable(false);
        setTable(true);
      })
      .catch((err) => {
        console.log(err);
      });
    setEditForm(false);
  };
  const handlePerfEvalSubmit = (event) => {
    event.preventDefault();
    setTable(true);
    setLoading(true);

    let body = {
      monthyear: String(Monthyear),
      communication: String(Communication),
      collaboration: String(Collaboration),
      problemsolving: String(Problemsolving),
      quality: String(Quality),
      attendance: String(Attendance),
      meetdeadline: String(Meetdeadline),
    };
    axios
      .post(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/perfeval-ceo/" +
          SelectedEmp,
        body,
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((res) => {
        setTable(false);
        setTable(true);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <React.Fragment>
      {!loading ? (
        <div>
          {table ? (
            editForm ? (
              <PerfEvalCEOFormEdit
                onPerfEvalCEOEditUpdate={handlePerfEvalCEOEditUpdate}
                onFormEditClose={handleEditFormClose}
                editData={editData}
              />
            ) : (
              <PerfEvalCEOTable
                onAddPerfEvalCEO={handleAddPerfEvalCEO}
                onEditPerfEvalCEO={handleEditPerfEvalCEO}
                RefreshTable={RefreshTable}
                data={props.data}
                SelectedEmpID={SelectedEmp}
                SelectedEmpName={EmpName}
                SetNameID={SetNameID}
              />
            )
          ) : (
            <PerfEvalCEOForm
              onFormClose={handleFormClose}
              handlePerfEvalSubmit={handlePerfEvalSubmit}
              HandleEdit={HandleEdit}
              Monthyear={Monthyear}
              Communication={Communication}
              Collaboration={Collaboration}
              Problemsolving={Problemsolving}
              Quality={Quality}
              Attendance={Attendance}
              Meetdeadline={Meetdeadline}
            />
          )}{" "}
        </div>
      ) : (
        <div id="loading-bar">
          <RingLoader
            css={override}
            sizeUnit={"px"}
            size={50}
            color={"#0000ff"}
            loading={true}
          />
        </div>
      )}
    </React.Fragment>
  );
}
